/**
 * Backend often sends `null` for optional fields; Zod `.optional()` allows
 * `undefined` but not `null`. Normalize before validation so one bad null
 * does not reject an entire list payload.
 */
export function nullToUndefined<T>(value: T): T {
  if (value === null) return undefined as T;
  if (Array.isArray(value)) {
    return value.map((entry) => nullToUndefined(entry)) as T;
  }
  if (typeof value === "object" && value !== undefined) {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, entry]) => [
        key,
        nullToUndefined(entry),
      ]),
    ) as T;
  }
  return value;
}

export function extractUnknownArray(
  payload: Record<string, unknown>,
  key = "data",
): unknown[] | null {
  const value = payload[key];
  return Array.isArray(value) ? value : null;
}
